import { Icon } from '@fluentui/react';
import {
  AppsIcon,
  Button,
  ChevronEndMediumIcon,
  CloseIcon,
  ProviderConsumer as FluentUIThemeConsumer,
  Text
} from '@fluentui/react-northstar';
import { themeNames } from '@fluentui/react-teams';
import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { appState, AppStateContext } from '../../AppState';
import { sidenav_unarranged, SideNavProps } from '../../browser-pages/browser-components/SideNav';
import { getNodesByType, NodeType } from '../cache/NodeCache';
import {
  ADMINISTRATORS,
  AGENTS,
  ANALYSTS,
  SIDENAV_ARRANGED_KEYS
} from '../utils/constants';
interface Props {
  active?: number;
  menuClose?: () => void;
}

export const ENDUSER_ROUTES = [
  {
    key: 'request',
    path: '/request',
    iconElement: <Icon iconName="Ticket" className={`text-lg text-black`} />,
    title: 'Request'
  }
];

export const TicketBoardMobileMenu = (props: Props) => {
  const appContextState = appState();
  const [navItems, setNavItems] = useState<SideNavProps[]>(sidenav_unarranged.slice(0, 3));

  useEffect(() => { setMenuItems(); }, []);
  const setMenuItems = async () => {
    const menuItems = sidenav_unarranged.slice(0, 3);
    const nodes = await getNodesByType(NodeType.Page);
    nodes?.forEach(n => menuItems.push({ 
      key: `node-${n.Id}`, 
      path: `/customnode/${n.Id}`, 
      iconElement: n.Icon && n.Icon !== '' ? <img src={n.Icon} style={{ minWidth: "20px", minHeight: "20px", width: "20px" }} /> : <AppsIcon size='large' outline />, 
      title: n.Name, group: 'main' 
    }));

    setNavItems(menuItems);
  }

  const renderSideNavItems = (theme: themeNames) => {
    return navItems.map((nav, _i) => (
      <NavLink
        to={nav.path}
        className={`block cursor-pointer `}
        activeStyle={
          SIDENAV_ARRANGED_KEYS[props.active - 1]?.toLowerCase() ===
            nav.key?.toLowerCase()
            ? {
              backgroundColor: '#f5f5f5',
              fontWeight: 600
            }
            : {}
        }
        onClick={props.menuClose}
      >
        <div className={`flex justify-between m-5 mb-5 `}>
          <div className="flex items-center">
            <Text content={nav.iconElement} className={`${theme === themeNames.Default ? "text-black" : "text-white"}`} />
            <Text
              content={nav.title}
              className={`pl-3 truncate ${appContextState.isSidenavCollapsed ? 'md:hidden' : ''} ${theme === themeNames.Default ? "text-black" : "text-white"}`}
            />
          </div>
          <div>
            <ChevronEndMediumIcon size="large" className={`${theme === themeNames.Default ? "text-black" : "text-white"}`} />
          </div>
        </div>
      </NavLink>
    ));
  }

  return (
    <AppStateContext.Consumer>
      {_state => {
        return (
          <FluentUIThemeConsumer
            render={globalTheme => (
              <div
                onClick={props.menuClose}
                className={`bg-black bg-opacity-50 fixed top-0 w-full h-full`}
                style={{ zIndex: 1000 }}
              >
                <div
                  className={`animation--hide-and-show fixed top-0 w-3/4 bg-white h-full overflow-auto`}
                  onClick={e => {
                    e.stopPropagation();
                  }}
                  style={{ zIndex: 1100, background: globalTheme.siteVariables.colorScheme.default.background }}
                >
                  <div>
                    <Button
                      icon={<CloseIcon size="large" className={`${_state.theme === themeNames.Default ? "text-black" : "text-white"}`} />}
                      text
                      iconOnly
                      title="Remove"
                      onClick={() => props.menuClose()}
                      styles={{
                        alignSelf: 'center',
                        marginLeft: '10px',
                        marginTop: '5px'
                      }}
                    />
                    <ul className={`mt-5`}>
                      {appContextState.userRoles.roles.includes(ADMINISTRATORS) || appContextState.userRoles.roles.includes(ANALYSTS) || appContextState.userRoles.roles.includes(AGENTS) ? (renderSideNavItems(_state.theme)) : (
                        <>
                          {ENDUSER_ROUTES.map(nav => (
                            <NavLink
                              to={nav.path}
                              className={`block cursor-pointer`}
                              activeStyle={{
                                backgroundColor: '#f5f5f5',
                                fontWeight: 600
                              }}
                            >
                              <div className={`flex justify-between m-5 mb-5 `}>
                                <div className="flex items-center">
                                  {nav.iconElement}
                                  <Text
                                    content={nav.title}
                                    className={`pl-3 truncate ${appContextState.isSidenavCollapsed ? 'hidden' : ''}`}
                                  />
                                </div>
                                <div>
                                  <ChevronEndMediumIcon size="large" />
                                </div>
                              </div>
                            </NavLink>
                          ))}
                        </>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            )} />
        );
      }}
    </AppStateContext.Consumer>
  );
};
